
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetTermsOfUseContent, GetTermsOfUseContentResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetTermsOfUseContentResponse, GetTermsOfUseContentResponse>) => response?.data?.content;
const getError = (response?: SWRResponse<GetTermsOfUseContentResponse, GetTermsOfUseContentResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetTermsOfUseContentResponse, GetTermsOfUseContentResponse>) => ({});

const useGetTermsOfUseContent = (query?: Partial<GetTermsOfUseContent>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetTermsOfUseContent(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTermsOfUseContent;